export default "__VITE_ASSET__fb964b9d__"